/* eslint-disable no-loop-func */
import React from 'react';
import { View, StyleSheet } from '@react-pdf/renderer';
import moment from 'moment';
import Utils from "../utils"
import mergePdf from '../../services/mergePdf';
import getPdfAll from '../../services/getPdfAll';

// Create styles
const styles = StyleSheet.create({
  page: {
    flexDirection: 'row',
    backgroundColor: '#FFFFFF',
    fontFamily: 'regular',
    paddingBottom: 90
  },
  section: {
    margin: 10,
    padding: 10,
    flexGrow: 1
  },
  table: { paddingRight: 10, paddingLeft: 10, display: "table", width: "auto", borderStyle: "solid", borderWidth: 1, borderRightWidth: 0, borderBottomWidth: 0 }, 
  tableRow: { margin: "auto", flexDirection: "row" }, 
  tableCol: { width: "25%", borderStyle: "solid", borderWidth: 1, borderLeftWidth: 0, borderTopWidth: 1 }, 
  tableCell: { margin: "auto", marginTop: 5, fontSize: 10 },
  myTableCell: { width: '25%', margin: "auto" },
});


export default class PdfDocument extends React.Component {

    static async getAddress (event, companies, breaks, meetings, updateWaitDialog, selectedStartDate, selectedEndDate){

        return new Promise(async function (resolve, reject) {

        var pdfPages = [];

        var companyCount = 0;
        
        while (companyCount < companies.length) {

            updateWaitDialog(companyCount + '/' + companies.length);
            var company = companies[companyCount];

            var filterMeetings = meetings.filter((elem) => elem.company_id == company.id);
            var filterBreaks = breaks.filter((elem) => elem.subject == company.id);

            var startDate = event.startDate;
            var endDate = event.endDate;

            startDate = moment(startDate, "DD/MM/yyyy");
            endDate = moment(endDate, "DD/MM/yyyy");

            var infoSchedules = event.brokersInfoSchedulesCompaniesEnabled;

            var eventDays = [];
            var tempDate = startDate;
            while (tempDate <= endDate){
                eventDays.push(moment(tempDate));
            tempDate = tempDate.add(1, 'd');
            }

            let days = [];
            eventDays.forEach(v => {
                let date = moment(v).format('DD/MM/yyyy');
                let dateComplete = moment(v).format('dddd, DD MMMM yyyy');
                
                let filterMeetingsDate = filterMeetings.filter((elem) => elem.date == date);
                let filterBreaksDate = filterBreaks.filter((elem) => elem.date == date);
                var infoSchedules = event.brokersInfoSchedulesCompaniesEnabled;

                let sortMeetings = filterMeetingsDate.sort((a, b) => {
                    var time1 = moment(a.date + " " + a.hour+":"+a.minutes, "DD/MM/yyyy HH:mm");
                    var time2 = moment(b.date + " " + b.hour+":"+b.minutes, "DD/MM/yyyy HH:mm");

                    return time1 - time2;
                });

                let sortBreaks = filterBreaksDate.sort((a, b) => {
                    var time1 = moment(a.date + " " + a.hour+":"+a.minutes, "DD/MM/yyyy HH:mm");
                    var time2 = moment(b.date + " " + b.hour+":"+b.minutes, "DD/MM/yyyy HH:mm");

                    return time1 - time2;
                });

                var meetings = [];

                    Utils.getHoursArray().map(hh => {
                        return Utils.getMinutesArray().map(mm => {

                            sortBreaks.forEach(b => {
                                if (b.break_type == 'Unavailable') return <View />;
                                if (b.minutes != mm || b.hour != hh) return <View />;
                                let breakTime = moment(parseInt(b.hour)+":"+parseInt(b.minutes), "hh:mm");
                                let breakEndTime = moment(breakTime).add(b.slots * 5, 'minutes');

                                let strTime = moment(breakTime).format("HH:mm");
                                let strEndTime = moment(breakEndTime).format("HH:mm");

                                var elem = {
                                    "time": strTime + ' - ' + strEndTime,
                                    "description": b.break_type,
                                    "notes": ""
                                };
                                meetings.push(elem);

                            })

                            sortMeetings.forEach(m => {
                                
                                var notes = m.notes;
                                notes = notes.replace('Click here to join the meeting', '<b>Click here to join the meeting</b>');                            

                                if (m.minutes != mm || m.hour != hh) return <View />;
                                let meetingTime = moment(parseInt(m.hour)+":"+parseInt(m.minutes), "hh:mm");
                                let meetingEndTime = moment(meetingTime).add(m.slots * 5, 'minutes');

                                let strTime = moment(meetingTime).format("HH:mm");
                                let strEndTime = moment(meetingEndTime).format("HH:mm");

                                var companiesList = [];
                                m.investors.sort((a, b) => {
                                    var strA = a.company + a.name;
                                    var strB = b.company + b.name;                     
                                    return strA.localeCompare(strB);
                                }).map(inv => {
                                    if (inv.isAnalyst == 0 && companiesList.indexOf(inv.company) == -1)
                                        companiesList.push(inv.company);
                                });

                                var meetingDesc = "";

                                if (companiesList.length == 0) meetingDesc += "Analysts Meeting with ";
                                else if (companiesList.length == 1) meetingDesc += "1 to 1 Meeting with ";
                                else if (companiesList.length < 5) meetingDesc += "1 to Few Meeting with ";
                                else meetingDesc += "Group Meeting with ";

                                // NEW FEATURE - Add representatives

                                const representativesArray = m.rapresentative.split(';');
                                const excludedRepresentativesArray = m.excludedRapresentatives.split(';');
                                if (representativesArray.length > 0) {
                                    representativesArray.map((person) => {
                                        if (excludedRepresentativesArray.indexOf(person) == -1) {
                                            meetingDesc += person;
                                            if (representativesArray.indexOf(person) != (representativesArray.length - 1)) {
                                                meetingDesc += "; ";
                                            }
                                        }
                                    });
                                    meetingDesc += ":<br>";
                                } 

                                m.investors.map((investor, index) => {
                                    meetingDesc += "<b>"+investor.company+"</b>" + ' - ' + investor.name;
                                    if (infoSchedules == 1) 
                                        meetingDesc += ' (hosted by ' + investor.broker+ ')';
                            
                                    if (index != m.investors.length - 1)
                                        meetingDesc += "<br/>";
                                });
                                
                                var elem = {
                                    "time": strTime + ' - ' + strEndTime,
                                    "description": meetingDesc,
                                    "notes": notes !== undefined ? notes.trim().replaceAll('<a', '<a style="font-weight: bold; color: #7B83EB;"').replaceAll('<strong>', '<b>').replaceAll('</strong>', '</b>') : ''
                                };
                                meetings.push(elem);
                            }) 

                    })
                })
                
                if (sortMeetings.length > 0)
                    days.push({
                        "date": dateComplete,
                        "meetings": meetings,
                    });
            });

            var i = 0;
        var pdfJson = { "folder": "", "fileName": company.name.replaceAll('/', '_') + ' - ' + event.eventName.replaceAll('/', '_'), "documents" : [] };
        var i = 0;
        var count = 0;
        while (i < days.length) {

            var d = days[i];
            if (d.meetings.length <= 0){
                i++;
                continue;
            }
            count++;

            /*var json = {
                "documents": [
                    {
                        "banner": event.bannerImageUrl,
                        "timezone": event.timezoneInformation,
                        "subject": event.eventName + ' - ' + company.name,
                        "footerText": event.notes,
                        "subjectDescription": company.notes,
                        "days": [d], 
                        "cDay": d,
                    }
                ]
            };*/

            pdfJson.documents.push({
                "banner": event.bannerImageUrl,
                "timezone": event.timezoneInformation,
                "subject": event.eventName + ' - ' + company.name,
                "footerText": event.notes.trim().replaceAll('<a', '<a style="font-weight: bold; color: #7B83EB;"').replaceAll('<strong>', '<b>').replaceAll('</strong>', '</b>'),
                "subjectDescription": company.notes,
                "days": [d], 
                "cDay": d,
            });
    
            var ret = await getPdfAll('', '', pdfJson);
            let fileUrl = JSON.parse(ret).fileUrl;
            if (fileUrl != undefined)
                pdfPages.push(fileUrl);
    
                i++;
            };

            companyCount++;
        }

        pdfPages = [...new Set(pdfPages)];
        var inputJson = {
            "files" : pdfPages,
            "fileName" : event.eventName + ' - ' + "companies.pdf"
        };
        
        var retUrl = await mergePdf('', '', inputJson);
        resolve('http://fixmeeting.eu/'+JSON.parse(retUrl).fileUrl);
    }
    )}
}
